export const getSuffix = (filename: string) => {
  const match = filename.match(/\.([a-zA-Z]+)$/);
  if (match === null) {
    return null;
  }
  return match[1].toLowerCase();
};
